export default "__VITE_PUBLIC_ASSET__aa1bbd00__"